export * from "./QuizResultMCQ";
